function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 5a5 5 0 015 5v10a5 5 0 01-5 5H10a5 5 0 01-5-5V10a5 5 0 015-5h10z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20 7H10a3 3 0 00-2.995 2.824L7 10v10a3 3 0 002.824 2.995L10 23h10a3 3 0 002.995-2.824L23 20V10a3 3 0 00-2.824-2.995L20 7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 22h-2v-1H8v-1h4v-2.5H8v-1h4V14H8v-2h4V8h2v4h2.5V8h1v4H20V8h1v4h1v2h-1v2.5h1v1h-1V20h1v1h-1v1h-1v-1h-2.5v1h-1v-1H14v1zm0-2h2.5v-2.5H14V20zm6-2.5h-2.5V20H20v-2.5zm-6-1h2.5V14H14v2.5zm6-2.5h-2.5v2.5H20V14z"
});

function SvgQInteractiveTableTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref, _ref2, _ref3);
}

export default SvgQInteractiveTableTypeIcon;